import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';

import classes from './DownloadButton.scss';

export default class DownloadButton extends PureComponent {
  static propTypes = {
    className:    PropTypes.string,
    title:        PropTypes.string.isRequired,
    size:         PropTypes.string,
    ext:          PropTypes.string.isRequired,
    url:          PropTypes.string,
    icon:         PropTypes.node,
    iconClick:    PropTypes.func,
  };

  render() {
    const { title, size, ext, url, downloadTitle, icon, iconClick } = this.props;

    return (
      <div className={classNames(classes.button, this.props.className, {[classes.button__hover]: !!url})}>
        <div className={classNames(classes.icon, {[classes.iconAction]: iconClick})} onClick={iconClick}>
          {icon || <GetAppOutlinedIcon />}
        </div>
        <div className={classes.content}>
          <div className={classes.title}>{title}</div>
          <div className={classes.text}>
            {size} ({ext})
          </div>
        </div>
        {url && <a className={classes.link} href={url} target="_blank" rel="noopener noreferrer">{downloadTitle}</a>}
      </div>
    );
  }
}
